export const environment = {
  appName: 'Clubes de Leitura',
  zustandStoreVersion: 1,
  noCoverBook: '/assets/no_cover_thumb.gif',
  noAvatar: '/assets/Avatar.png',
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    google: {
      get: 'q={search}'
    },
    genres: {
      getAll: '/genre',
      createUser: '/genre/users/{userId}',
      createClub: '/genre/clubs/{clubId}',
      createBook: '/genre/books/{bookId}',
      getUserGenres: '/genre/users/{userId}',
      getBookGenres: '/genre/books/{bookId}',
      getClubGenres: '/genre/clubs/{clubId}'
    },
    auth: {
      login: '/auth/',
      refresh_token: '/auth/refresh-token',
    },
    club: {
      get: '/club/{clubId}',
      getAll: '/club?page={page}',
      create: '/club/users/{userId}',
      edit: '/club/{clubId}',
      getUsers: '/club/{clubId}/users?wasAccepted={wasAccepted}',
      archiveClub: '/club/{clubId}/archive',
      editUserInClub: '/club/{clubId}/users/{userId}?action={action}',
      addUserInClub: '/club/{clubId}/users/{userId}',
    },
    user: {
      create: '/user',
      get: '/user/{userId}',
      update: '/user/{userId}',
      validateEmail: '/user/{userId}/email?email={email}',
      validateNick: '/user/{userId}/nick?nick={nick}',
      getClubs: '/user/{userId}/clubs?role={role}',
      getClubUser: '/user/{userId}/club/{clubId}'
    },
    files: {
      clubImage: '/upload/clubs/{clubId}/profile',
      userImage: '/upload/users/{userId}/profile',
      bookImage: '/upload/books/{bookId}/cover'
    },
    bookcase: {
      getUserBookcase: '/bookcase/users/{userId}?stateBook={stateBook}',
      getPagesAndBooksCountForUser: '/bookcase/users/{userId}/count',
      getPagesAndBooksCountForClub: '/bookcase/clubs/{clubId}/count',
      get: '/bookcase/{bookcaseId}',
      updateStatus: '/bookcase/{bookcaseId}',
      createUserBookcase: '/bookcase/users/{userId}/books/{bookId}',
      createUserBookcaseByGoogleId: '/bookcase/users/{userId}/google/{googleId}',
      createClubBookcaseByGoogleId: '/bookcase/clubs/{clubId}/google/{googleId}',
      getBookUserBookcase: '/bookcase/users/{userId}/books/{bookId}',
      createClubBookcase: '/bookcase/clubs/{clubId}/books/{bookId}',
      getClubBookcase: '/bookcase/clubs/{clubId}?stateBook={stateBook}',
      getLastUserBook: '/bookcase/users/{userId}/last',
      getLastClubBook: '/bookcase/clubs/{clubId}/last',
    },
    share: {
      emailValidate: '/share/email',
      sendEmailToResetPassword: '/share/reset-password-create-token',
      sendTokenToResetPassword: '/share/reset-password/{token}',
    },
    elections: {
      getAll: '/election',
      getResults: '/election/{electionId}/result',
      get: '/election/{electionId}',
      create: '/election/clubs/{clubId}',
      getUserElection: '/election/users/{userId}?type={type}&time={time}',
      getClubElection: '/election/clubs/{clubId}?type={type}&time={time}',
      candidates: {
        getAll: '/election/{electionId}/candidates',
        create: '/election/{electionId}/candidates',
      },
      ballotBox: {
        getUserVote: '/election/{electionId}/users/{userId}/candidates',
        insert: '/election/{electionId}/users/{userId}/candidates/{candidateId}',
        delete: '/election/{electionId}/users/{userId}/candidates/{candidateId}'
      }
    },
    candidates: {
      get: '/candidate/election/{electionId}'
    },
    book: {
      get: '/book/{bookId}',
      getAll: '/book',
      create: '/book',
      createBookByGoogleId: '/book/google/{googleId}',
      getByGoogleId: '/book/google/{googleId}',
      listByGoogle: '/book/third/google?search={search}&type={type}&page={page}&size=20',
      getFromGoogleId: '/book/third/google/{googleId}',
    },
    meet: {
      add: '/meet/clubs/{clubId}',
      getClubMeets: '/meet/clubs/{clubId}?date={date}',
      getUserMeets: '/meet/users/{userId}?date={date}',
      getLastestClubMeets: '/meet/clubs/{clubId}/last',
      getById: '/meet/{meetId}'
    },
    comment: {
      getByBook: '/comment',
      create: '/comment/add'
    },
    like: {
      create: '/like/add',
      deslike: '/like/deslike'
    },
    forum: {
      getClubForum: '/forum/club/{clubId}',
      getByUser: '/forum/user/{userId}',
      create: '/forum/club/{clubId}/user/{userId}',
    },
    forumTopic: {
      create: '/forum-topic/club/{clubId}/forum/{forumId}/user/{userId}',
      getById: '/forum-topic/club/{clubId}/forum/{forumId}/topic/{forumTopicId}',
      getByClubAndForumId: '/forum-topic/club/{clubId}/forum/{forumId}/topics?wasApproved={wasApproved}',
      approve: '/forum-topic/club/{clubId}/forum/{forumId}/approve-topic/{forumTopicId}'
    },
    forumTopicPost: {
      create: '/forum-topic-post/club/{clubId}/forum/{forumId}/topic/{forumTopicId}/user/{userId}',
      getByForumTopic: '/forum-topic-post/club/{clubId}/forum/{forumId}/topic/{forumTopicId}/posts'
    },
    notification: {
      getNotification: '/notification/{notificationId}',
      markAsRead: '/notification/{notificationId}/read',
      getByUser: '/notification/user/{userId}?isRead={isRead}',
      markAllAsRead: '/notification/user/{userId}/read',
      getByClubUser: '/notification/user/{userId}/club/{clubId}?isRead={isRead}',
      createClubNotification: '/notification/user/{userId}/club/{clubId}'
    },
    attendance: {
      registerMeetAttendance: '/attendance/club/{clubId}/meet/{meetId}/register-all',
      getAttendanceAtClubMeetingsByUser: '/attendance/club/{clubId}/user/{userId}',
      getAttendancesByMeetId: '/attendance/club/{clubId}/meet/{meetId}/',
      getAttendanceSummaryByMeetId: '/attendance/club/{clubId}/meet/{meetId}/summary',
      getSummaryListByClubId: '/attendance/club/{clubId}/summary-all',
      getByUserAndMeet: '/attendance/club/{clubId}/meet/{meetId}/user/{userId}'
    },
    clubBookReview: {
      registerClubBookReview: '/review/club/{clubId}/meet/{meetId}/user/{userId}/register',
      getByMeetAndUser: '/review/club/{clubId}/meet/{meetId}/user/{userId}',
      getSummaryByMeet: '/review/club/{clubId}/meet/{meetId}',
    }
  }
}